import React, { createContext, useCallback, useContext, useMemo } from 'react';
import axios from 'axios';
import { LANGS, getLang, setLang as storeLang } from './index';
import { API_URL } from '../config';

const Ctx = createContext({ lang: 'en', setLang: () => {}, langs: LANGS });
export const useLang = () => useContext(Ctx);

/**
 * The language is read once when the app starts, so constants that hold labels (menus, tabs, statuses) are
 * translated too. Changing it stores the choice, tells the server (it writes reminders in that language) and reloads.
 */
export default function I18nProvider({ children }) {
  const lang = getLang();
  const setLang = useCallback(async (code) => {
    if (code === getLang()) return;
    storeLang(code);
    try {
      await axios.post(`${API_URL}/api/user/language`, { language: code }, { timeout: 2500 });
    } catch (e) {
      /* logged out or offline: the choice is kept locally and sent on the next login */
    }
    window.location.reload();
  }, []);
  const value = useMemo(() => ({ lang, setLang, langs: LANGS }), [lang, setLang]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}
